import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocalStorage } from '@rehooks/local-storage';
import { COOKIE_ACCEPTED, localStorageKeys } from 'constants';
import routes from 'constants/routes';
import { trackOpenAIPageView } from 'utils/openaiPixel';

const PAGES = {
  [routes.home]: { id: 'home', name: 'Startseite' },
  [routes.old]: { id: 'home-old', name: 'Startseite (alt)' },
  [routes.goodie]: { id: 'goodie', name: 'Goodie-Aktion' },
  [routes.demo]: { id: 'demo', name: 'Demo buchen' },
  [routes.imprint]: { id: 'imprint', name: 'Impressum' },
  [routes.policy]: { id: 'policy', name: 'Datenschutz' },
};

const pageFor = (pathname) =>
  PAGES[pathname] || {
    id: pathname.replace(/^\//, '') || 'home',
    name: pathname,
  };

/**
 * Sends a `page_viewed` event to the OpenAI pixel once per route, but only
 * while cookie consent is granted (events sent before consent are dropped by
 * the SDK and never replayed, so we wait for it instead).
 */
const PageViewTracker = () => {
  const { pathname } = useLocation();
  const [cookieConsent] = useLocalStorage(localStorageKeys.cookieConsent);
  const lastTracked = useRef(null);

  useEffect(() => {
    if (cookieConsent !== COOKIE_ACCEPTED || lastTracked.current === pathname) {
      return;
    }
    lastTracked.current = pathname;
    trackOpenAIPageView(pageFor(pathname));
  }, [pathname, cookieConsent]);

  return null;
};

export default PageViewTracker;
